import Link from 'next/link';

export default function DocumentList(props)
{
    const { className, heading, items, anchorId } = props;

    const itemsContent = items.map((item, index) => (
        <li key={ index } className="mb-2">
            <Link href={ item.href } className="no-underline hover:underline" target="__target">
                { item.title }
            </Link>
        </li>
    ));

    let anchor = '';

    if ( anchorId ) {
        anchor = (
            <a id={ anchorId } className="absolute top-[-150px]"></a>
        );
    }

    return (
        <div className={ "sol-markdown-content relative" + ( className ? " " + className : "" ) }>
            { anchor }
            <h6>{ heading }</h6>
            <ul className="text-light/50">
                { itemsContent }
            </ul>
        </div>
    );
}